import * as pslbs from '../services/pslbs';

export default {
  namespace: 'pslbs',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getLinkList({ payload: { values }, callback }, { call, put }) {
      console.log({ values });
      const response = yield call(pslbs.getLinkList, values);
      yield put({
        type: 'save',
        payload: {
          pslbs: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *approveLink({ payload: { values }, callback }, { call, put }) {
      const response = yield call(pslbs.approveLink, values);
      yield put({
        type: 'save',
        payload: {
          pslbs: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
